import { defineComponent as _defineComponent } from 'vue'
import { useContext, computed, ref, onMounted, useStore } from '@nuxtjs/composition-api';
import { State } from '@/store';

interface Props {
  type: string;
  code?: number | string | (string | null)[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginError',
  props: {
    type: null,
    code: { default: undefined }
  },
  setup(__props: any) {

const { $config, $isFlagOn } = useContext();
const $store = useStore<State>();



const deviceId = computed(() => $store.getters.deviceId);
const pwResetLink = computed(
  () => `${$config.wpURL}/password-reset/?amp_device_id=${deviceId.value}`
);

return { __sfc: true,$config, $isFlagOn, $store, deviceId, pwResetLink }
}

})